var exports = {
  "button": "MediaPlayButton.module__button___Y0lYT3",
  "small": "MediaPlayButton.module__small___Y0lYT3",
  "medium": "MediaPlayButton.module__medium___Y0lYT3",
  "large": "MediaPlayButton.module__large___Y0lYT3",
  "xlarge": "MediaPlayButton.module__xlarge___Y0lYT3",
  "overlay": "MediaPlayButton.module__overlay___Y0lYT3",
};

__webpack_require__.r(module.exports = exports);
